import React from 'react';

import { css } from '@emotion/core';
import { Box, Flex, Heading, Text } from '@rebass/emotion';
import Colors from '@theme/colors';

interface IconTextProps {
  text: string;
  header: string;
}

const IconText = ({ text, header }: IconTextProps) => {
  return (
    <Flex>
      <Box mt={3} ml={2}>
        {header && (
          <Heading
            css={css`
              text-transform: uppercase;
            `}
            fontSize={[15, 12, 15]}
            color={Colors.science37}
          >
            {header}
          </Heading>
        )}
        <Text fontSize={['1.4rem', '1.3rem', '1.3rem', '1.1rem']} fontWeight="1000">
          <span>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </span>
        </Text>
      </Box>
    </Flex>
  );
};

export default IconText;
